import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deal: null,
  totalStats: null,
  isLoading: false,
  isError: false,
  error: "",

  isSaving: false,
  isSaveSuccess: false,

  isDeleting: false,
  isDeleteSuccess: false,
  isDeleteError: false,

  isRecovering: false,
  isRecoverSuccess: false,
};

const linkedinPromotionSlice = createSlice({
  name: "linkedinPromotion",
  initialState: initialState,
  reducers: {
    getLinkedinDeal: (state) => {
      state.isLoading = true;
      state.deal = null;
    },
    getLinkedinDealSuccess: (state, action) => {
      state.deal = action.payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getLinkedinDealFailed: (state, action) => {
      state.deal = null;
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    saveLinkedinDeal: (state) => {
      state.isSaving = true;
      state.isSaveSuccess = false;
    },
    saveLinkedinDealSuccess: (state, action) => {
      state.deal = action.payload;
      state.isSaving = false;
      state.isSaveSuccess = true;
    },
    saveLinkedinDealFailed: (state) => {
      state.isSaving = false;
      state.isSaveSuccess = false;
    },
    saveLinkedinDealReset: (state) => {
      state.isSaveSuccess = false;
    },

    deleteLinkedinDeal: (state) => {
      state.isDeleting = true;
      state.isDeleteSuccess = false;
      state.isDeleteError = false;
    },
    deleteLinkedinDealSuccess: (state) => {
      state.deal = null;
      state.isDeleting = false;
      state.isDeleteSuccess = true;
    },
    deleteLinkedinDealFailed: (state) => {
      state.isDeleting = false;
      state.isDeleteSuccess = false;
      state.isDeleteError = true;
    },
    deleteLinkedinDealReset: (state) => {
      state.isDeleteSuccess = false;
      state.isDeleteError = false;
    },

    recoverLinkedinDeal: (state) => {
      state.isRecovering = true;
      state.isRecoverSuccess = false;
    },
    recoverLinkedinDealSuccess: (state) => {
      state.isRecovering = false;
      state.isRecoverSuccess = true;
    },
    recoverLinkedinDealFailed: (state) => {
      state.isRecovering = false;
      state.isRecoverSuccess = false;
    },
    recoverLinkedinDealReset: (state) => {
      state.isRecoverSuccess = false;
    },

    getTotalLinkedinStats: (state) => {
      state.isLoading = true;
    },
    getTotalLinkedinStatsSuccess: (state, action) => {
      state.totalStats = action.payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getTotalLinkedinStatsFailed: (state, action) => {
      state.totalStats = null;
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },
  },
});

export const {
  getLinkedinDeal,
  getLinkedinDealSuccess,
  getLinkedinDealFailed,
  saveLinkedinDeal,
  saveLinkedinDealSuccess,
  saveLinkedinDealFailed,
  saveLinkedinDealReset,
  deleteLinkedinDeal,
  deleteLinkedinDealSuccess,
  deleteLinkedinDealFailed,
  deleteLinkedinDealReset,
  recoverLinkedinDeal,
  recoverLinkedinDealSuccess,
  recoverLinkedinDealFailed,
  recoverLinkedinDealReset,
  getTotalLinkedinStats,
  getTotalLinkedinStatsSuccess,
  getTotalLinkedinStatsFailed,
} = linkedinPromotionSlice.actions;

export default linkedinPromotionSlice.reducer;
